/**
 * Pure file-utility helpers with no React or component dependencies.
 * Shared by hooks, components, and tests.
 */

/**
 * Split a list of files into valid (within limit) and oversized buckets.
 * Pure function — no side-effects.
 */
export const filterFiles = (
  files: File[],
  maxBytes: number,
): { valid: File[]; oversized: File[] } => ({
  valid: files.filter((f) => f.size <= maxBytes),
  oversized: files.filter((f) => f.size > maxBytes),
});
